import { render, staticRenderFns } from "./OrderTableCard.vue?vue&type=template&id=eb0c0278&scoped=true&"
import script from "./OrderTableCard.vue?vue&type=script&lang=js&"
export * from "./OrderTableCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableCard.vue?vue&type=style&index=0&id=eb0c0278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0c0278",
  null
  
)

export default component.exports